<template>
  <div id="app">
    <router-view> </router-view>
    <Loading />
  </div>
</template>

<script>
/* eslint-disable */
import TicketForm from "./components/TicketForm.vue";
import Loading from "@/components/loading/loading";

export default {
  name: "App",
  components: {
    TicketForm,
    Loading,
  },
};
</script>

<style></style>
